import React, { FC } from 'react';

import { sanitizeTableContent } from 'helpers/html';

export const CellValueViewer: FC<any> = ({ value }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: sanitizeTableContent(value) }}/>
  );
};
